// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"500":"modal-connect-wallet","810":"modal-buy-now"}[chunkId] + "." + {"500":"293c06c7","810":"5ed99418"}[chunkId] + ".chunk.css";
};